module.exports = __webpack_public_path__ + "img/footer-map.80b0cb4f.png";